import { Config } from "../config/config";
import { Helper } from "../util/helper";
import { HTTPService } from "../util/httpManager";
import { BaseComponentProps } from "./baseComponentProps";
import { Button } from "./button";
import React from "react";

export default class TeamsMailSelector extends React.Component<TeamsMailSelectorProps, { suggestedMail: string }>{
    private inputRef: HTMLInputElement;
    private placeholder = "";//"no-reply@example.com";
    private textbox: kendo.ui.TextBox;

    constructor(props: TeamsMailSelectorProps) {
        super(props)
        this.state = {
            suggestedMail: null
        }
        this.tryGetTeamsMail();
    }

    private tryGetTeamsMail = async () => {
        if (!Config.settings.teamsIntegrationActive) return;
        let url: string;
        switch (this.props.context.contextType) {
            case "userSettings":
                url = `InnoBot/GetUserByPwUser?pwuser=${this.props.context.keyVal1}`;
                break;
            case "resource":
                url = `InnoBot/GetUserByRessNr?ressNr=${this.props.context.keyVal1}`;
                break;
            default:
                console.log(this.props.context.contextType)
                break;
        }
        if (!url) return;
        try {
            const result = await HTTPService.noBusyIndicator().get<{ mail: string }>(url);
            this.setState({ suggestedMail: result.mail })
        } catch (_) {}
        
    }

    private onChange = (value: string) => {
        this.props.onChange(this.props.field, value);
    }

    private update = (value: string) => {
        this.textbox.value(value)
        this.onChange(value)
    }

    componentDidMount() {
        this.textbox = $(this.inputRef).kendoTextBox({
            value: (this.props.value || ""),
            readonly: this.props.disabled,
            placeholder: (this.placeholder),
            change: (ev) => {
                const value = ev.sender.value();
                this.onChange(value)
            }
        }).data("kendoTextBox");
    }

    componentDidUpdate(prevProps: TeamsMailSelectorProps) {
        if (prevProps.value != this.props.value) {
            this.update(this.props.value)
        }
    }

    render() {
        return (
            <>
                <style>
                    {".teams_mail_selection{display: flex; border-radius: var(--border-radius)}"}
                    {".teams_mail_selection[data-show-button='true'] span.k-input {border-radius: var(--rounded-left)}"}
                    {".teams_mail_selection[data-show-button='true'] span.k-input:focus-within {box-shadow: none; border-color: rgb(206, 212, 218)}"}
                    {".teams_mail_selection[data-show-button='true']:focus-within {box-shadow: 0 0 0 0.25rem var(--secondary-color-light); border:1px solid var(--secondary-color)}"}
                </style>
                <div className="teams_mail_selection" data-show-button={!Helper.isNullOrEmpty(this.state.suggestedMail)} >
                    <input
                        name={this.props.field.model} style={{ width: "100%" }}
                        data-label={this.props.field.name}
                        required={this.props.required}
                        ref={(ref) => { this.inputRef = ref; }}
                        readOnly={this.props.disabled}
                        type={"email"}
                        placeholder={this.placeholder}
                    >
                    </input>
                    <Button iconName="share" handleClick={() => { this.update(this.state.suggestedMail) }} buttonStyle={{ display: Helper.isNullOrEmpty(this.state.suggestedMail) ? "none" : "flex", borderColor: "#ced4da", borderLeft: "none", height: "38px", width: "30px", backgroundColor: "rgb(228, 231, 235)", borderRadius: "var(--rounded-right)" }} />
                </div>
            </>
        );
    }
}

interface TeamsMailSelectorProps extends BaseComponentProps {
    value: string;
}